import HorizontalSplitter from "./HorizontalSpliter";

export { HorizontalSplitter as default };
